var exports = {
  "kL": "x127c5a35--dff7ee--container",
  "XT": "x127c5a35--dff7ee--comment_controls",
  "yE": "x127c5a35--dff7ee--comment_content",
};

module.exports = exports;
